@if (loading()) {
  <div class="loading">
    <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
  </div>
} @else if (errored()) {
  <glxy-alert type="error">
    {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.LOAD_ERROR' | translate }}
  </glxy-alert>
} @else if (jobs().length === 0) {
  <glxy-alert type="info">
    {{ 'AI_ASSISTANT.TESTING.JOBS_TO_BE_DONE.EMPTY' | translate }}
  </glxy-alert>
} @else {
  <div class="job-list">
    @for (stat of jobs(); track stat.testCase.id) {
      <button type="button" class="job-card-trigger" (click)="openDetail(stat)">
        <mat-card class="job-card">
          <mat-card-content>
            <div class="job-row">
              <div class="job-text">
                <div class="job-name">{{ stat.testCase.name }}</div>
                <div class="job-scenario">{{ stat.testCase.scenario }}</div>
              </div>
              <div class="job-rate" [class]="'tone-' + tone(stat.successRate)">
                {{ stat.successRate | percent }}
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </button>
    }
  </div>
}
